'use client'

import { useRouter } from 'next/navigation'
import { useEffect } from 'react'
import { CustomerHeader } from './customer-header'
import { createDiscoverySearchDefaults } from './search-defaults'

type SearchInput = Record<string, string | string[] | undefined>

export function LocalSearchDefaultsRedirect({ input }: { input: SearchInput }) {
  const router = useRouter()

  useEffect(() => {
    const params = new URLSearchParams()
    for (const [key, value] of Object.entries(input)) {
      const values = Array.isArray(value) ? value : value === undefined ? [] : [value]
      values.forEach((item) => params.append(key, item))
    }

    const defaults = createDiscoverySearchDefaults()
    if (!/^\d{4}-\d{2}-\d{2}$/.test(params.get('date') ?? '')) params.set('date', defaults.date)
    if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(params.get('time') ?? '')) params.set('time', defaults.time)
    router.replace(`/search?${params.toString()}`, { scroll: false })
  }, [input, router])

  return (
    <div className="search-page">
      <CustomerHeader surface="solid" />
      <main>
        <section className="search-results-heading" aria-live="polite">
          <div><h1>Finding tables near you</h1><p>Setting the date and time from your local time zone…</p></div>
        </section>
      </main>
    </div>
  )
}
